import { z } from 'zod';
import { t } from 'i18next';

export const FaqManageFormSchema = z.object({  
  iconName: z
    .string({ message: t('elements.form.icon.error')}),
  question: z
    .string({ message: t('elements.form.question.error')}),
  answer: z
    .string({ message: t('elements.form.answer.error')}),
  linkUrl: z
    .string().optional()
});

export type FaqManageFormData = z.infer<typeof FaqManageFormSchema>;